/* eslint-disable no-underscore-dangle */
import uniqueId from 'lodash/fp/uniqueId';

class ClientObject {
  __clientId?: string = uniqueId('clientId_');

  get clientId(): string | undefined {
    return this.__clientId;
  }
}

export default ClientObject;
